import {
  // eslint-disable-next-line no-restricted-imports
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
} from '@material-ui/core';
import { Theme } from '@emotion/react';
import { dialogActions } from 'omakase/Dialog/dialogCoreCssDefs';
import React from 'react';

export type DialogActionsStacking = boolean | 'mobile';

export interface DialogActionsBaseProps {
  /**
   * Whether the action contents are stacked in a column layout, with the option to stack only at
   * mobile widths
   */
  stack?: DialogActionsStacking;
}

export type DialogActionsProps = DialogActionsBaseProps & MuiDialogActionsProps;

const DialogActions: React.FunctionComponent<DialogActionsProps> = ({
  children,
  stack = false,
  ...rest
}) => {
  return (
    <MuiDialogActions
      disableSpacing
      css={(theme: Theme) => dialogActions(theme, { stack })}
      {...rest}
    >
      {children}
    </MuiDialogActions>
  );
};

export default DialogActions;
